import { getMessages } from '../../../../../../store/constants';

export const TITLE = getMessages().getText('ms.drive_permission_error');
